import { IN_HOUSE_GROUP, modelGroupOf, shownModel, type SessionView } from '../data/models';
import type { ModelInfo, ModelsResponse } from '../service/orchestrator-client';
import type { RouteModel } from '../types';

export const INVESTBANQ_AUTO_MODEL_ID = 'investbanq-ai';

function isInHouse(model: Pick<ModelInfo, 'group' | 'provider'>): boolean {
  return modelGroupOf(model).id === IN_HOUSE_GROUP;
}

function toRouteModel(model: ModelInfo): RouteModel {
  const group = modelGroupOf(model);
  return {
    id: model.id,
    label: model.label ?? model.id,
    group,
    providerLabel: group.label,
    kind: group.id === IN_HOUSE_GROUP ? 'internal' : 'commercial',
  };
}

export function internalModelFor(res: ModelsResponse, chatModelId?: string): RouteModel | null {
  if (res.override_active) return null;
  const rows = res.models.filter(isInHouse);
  const picked =
    rows.find((m) => m.id === chatModelId) ??
    rows.find((m) => m.id === INVESTBANQ_AUTO_MODEL_ID) ??
    rows[0];
  return picked ? toRouteModel(picked) : null;
}

export function hasCommercialModels(res: ModelsResponse): boolean {
  if (res.override_active) return res.override_model ? !isInHouse(res.override_model) : true;
  return res.models.some((m) => !isInHouse(m));
}

export function selectedRouteModel(
  res: ModelsResponse,
  modelId: string,
  view: SessionView = {},
): RouteModel | null {
  const shown = shownModel(res, modelId, view);
  if (!shown) return null;
  return {
    id: shown.id,
    label: shown.label,
    group: shown.group,
    providerLabel: shown.group.label,
    kind: shown.group.id === IN_HOUSE_GROUP ? 'internal' : 'commercial',
  };
}
